import { assertNever } from "@impero-com/common/utils/obj";

import { ConfirmationStep } from "./components/confirmationStep";
import { ExportAssignmentsStep } from "./components/exportAssignmentsStep";
import { UploadAssignmentsStep } from "./components/uploadAssignmentsStep";
import { useSpreadsheetProcessor } from "./hooks/useSpreadsheetProcessor";
import * as theme from "./theme.css";

export type BulkAssignStep = "export" | "upload" | "confirm";

interface BulkAssignmentStepsContainerProps {
    currentStep: BulkAssignStep;
    onStepChange: (step: BulkAssignStep) => void;
    onErrorChange: (hasError: boolean) => void;
}

export function BulkAssignmentStepsContainer({
    currentStep,
    onStepChange,
    onErrorChange,
}: BulkAssignmentStepsContainerProps) {
    const { status, controlReassignments, processFile, resetData } =
        useSpreadsheetProcessor();

    const renderStep = () => {
        switch (currentStep) {
            case "export":
                return <ExportAssignmentsStep onStepChange={onStepChange} />;
            case "upload":
                return (
                    <UploadAssignmentsStep
                        onStepChange={onStepChange}
                        onErrorChange={onErrorChange}
                        status={status}
                        processFile={processFile}
                        resetData={resetData}
                    />
                );
            case "confirm":
                if (!controlReassignments) {
                    return null;
                }
                return (
                    <ConfirmationStep
                        controlReassignments={controlReassignments}
                        onStepChange={onStepChange}
                    />
                );
            default:
                return assertNever(currentStep);
        }
    };

    return (
        <div className={theme.pageContent}>
            <div className={theme.stepContent}>{renderStep()}</div>
        </div>
    );
}
